import en from "./en";
import ru from "./ru";
import uz from "./uz";

const translations = {
  ru: { translation: ru },
  en: { translation: en },
  uz: { translation: uz },
};

export default translations;
